import React from "react";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import GwtGen1PolicyDetails from "./GwtGen1PolicyDetails";
import Assets from "./Assets";
import CarrierBasedIncome from "./GiftorIndividualIncome";
import Liabilities from "./Liabilities";
import GiftorDocuments from "./GiftorDocuments";


export function GiftorDetails(props:{enrollmentID?:string, isGWTGen2?:boolean}) {
    const { enrollmentID, isGWTGen2 } = props;
    const [gen1User, setGen1User] = React.useState<any>(null);

    return (
            <>
                <Grid item xs={12} md={12} className="mt20">
                    <Grid container>
                        <Grid item xs={12} md={12}>
                            <GwtGen1PolicyDetails gen1User={gen1User} setGen1User={setGen1User} isGWTGen2={isGWTGen2} />
                            <Grid container spacing={2}>
                                <CarrierBasedIncome isAgentGWT={isGWTGen2} />
                            </Grid>
                            <Assets />
                            <Liabilities />
                            <GiftorDocuments enrollmentID={enrollmentID} isGWTGen2={isGWTGen2} />
                        </Grid>
                    </Grid>
                </Grid>
            </>
    );
};
